import React from 'react'
import { ScoopSkeleton } from '../../../ScoopSkeleton/ScoopSkeleton'
import styles from './TableSkeleton.module.scss'

/**
 * TableSkeleton - Loading state for ScoopTable
 * Displays skeleton rows while data is loading
 */
const TableSkeleton = ({ rows = 5, columns = 4, rowHeight = 40, headerHeight = 44 }) => {
    return (
        <div className={styles.container}>
            {/* Header skeleton */}
            <div className={styles.header} style={{ height: headerHeight }}>
                {Array.from({ length: columns }).map((_, colIndex) => (
                    <div key={`header-${colIndex}`} className={styles.headerCell}>
                        <ScoopSkeleton variant="text" width="70%" height={20} animation="wave" />
                    </div>
                ))}
            </div>

            {/* Row skeletons */}
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <div key={`row-${rowIndex}`} className={styles.row} style={{ height: rowHeight }}>
                    {Array.from({ length: columns }).map((_, colIndex) => (
                        <div key={`cell-${rowIndex}-${colIndex}`} className={styles.cell}>
                            <ScoopSkeleton
                                variant="text"
                                width={`${60 + Math.random() * 30}%`}
                                height={16}
                                animation="wave"
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}

export default TableSkeleton
